const allMegaMenus = document.querySelectorAll('.dropdown-toggle-megamenu')

if (allMegaMenus) {
  allMegaMenus.forEach((element) => {
    element.addEventListener('click', (e) => {
      const target = e.target as HTMLElement
      if (target) {
        if (target.getAttribute('aria-expanded') === 'true') {
          target.setAttribute('aria-expanded', 'false')
          if (target.dataset.bsTarget) {
            document
              .getElementById(target.dataset.bsTarget)
              ?.classList.remove('show')
          }
        } else {
          document
            .querySelectorAll('.dropdown-toggle-megamenu[aria-expanded="true"]')
            .forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'))
          if (window.innerWidth > 1399) {
            document
              .querySelectorAll('.dropdown-fullwidth.show')
              .forEach((menu) => menu.classList.toggle('show'))
          }
          if (target.dataset.bsTarget) {
            document
              .getElementById(target.dataset.bsTarget)
              ?.classList.toggle('show')
          }
          if (element.closest('.dropdown-fullwidth')) {
            element.closest('.dropdown-fullwidth')?.classList.toggle('toggled')
          }
          element.setAttribute(
            'aria-expanded',
            element.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
          )
        }
      }
    })
  })
}

// Unternehmen Menü

const allSubToggles = document.querySelectorAll('.dropdown-sub-toggle')

if (allSubToggles) {
  allSubToggles.forEach((element) => {
    element.addEventListener('click', (e) => {
      const target = e.target as HTMLElement
      if (target) {
        if (target.getAttribute('aria-expanded') === 'true') {
          target.setAttribute('aria-expanded', 'false')
          if (target.dataset.bsTarget) {
            document
              .getElementById(target.dataset.bsTarget)
              ?.classList.remove('show')
          }
        } else {
          document
            .querySelectorAll('.dropdown-sub-toggle[aria-expanded="true"]')
            .forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'))
          document
            .querySelectorAll(
              '.content-wrap:not(#' + target.dataset.bsTarget + ')'
            )
            .forEach((wrap) => wrap.classList.remove('show'))
          document
            .querySelectorAll('.dropdown-sub-menu.show')
            .forEach((menu) => menu.classList.toggle('show'))
          if (target.dataset.bsTarget) {
            document
              .getElementById(target.dataset.bsTarget)
              ?.classList.toggle('show')
          }

          element.setAttribute(
            'aria-expanded',
            element.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
          )
        }
      }
    })
  })
}

// Mobile Menü

const mobileNavToggle = document.getElementById('mobileNavToggle')

if (mobileNavToggle) {
  mobileNavToggle.addEventListener('click', () => {
    mobileNavToggle.classList.toggle('is-active')

    if (mobileNavToggle.getAttribute('aria-expanded') === 'true') {
      document
        .querySelectorAll('.dropdown-fullwidth')
        .forEach((menu) => menu.classList.remove('toggled', 'show'))
      mobileNavToggle.setAttribute('aria-expanded', 'false')
    } else {
      document.querySelector('.level-1')?.classList.toggle('show')
      mobileNavToggle.setAttribute('aria-expanded', 'true')
    }
  })

  // Mobile go Back

  const goBack = document.querySelectorAll('.fullwidth-back')
  goBack.forEach((element) => {
    element.addEventListener('click', (e) => {
      const target = e.target as HTMLElement
      if (target) {
        document
          .querySelectorAll('.' + target.dataset.currentlevel)
          .forEach((dropdown) => {
            dropdown.classList.remove('show')
            document
              .querySelectorAll('.' + target.dataset.prevlevel)
              .forEach((prev) => {
                prev.classList.remove('toggled')
              })
          })
        document
          .querySelectorAll('.dropdown-sub-list a')
          .forEach((dropdownSubList) => {
            dropdownSubList.setAttribute('aria-expanded', 'false')
          })
      }
    })
  })
}

// Content on Hover (Desktop only)

document.addEventListener('DOMContentLoaded', function () {
  const contentToggles = document.querySelectorAll('.content-toggle')

  if (contentToggles) {
    contentToggles.forEach((toggle) =>
      toggle.addEventListener('mouseover', (e) => {
        if (e.target instanceof HTMLElement) {
          const target = e.target?.dataset.target
          if (target) {
            if (document.getElementById(target)) {
              const parent = document
                .getElementById(target)
                ?.closest('.dropdown-fullwidth')
              // get all content-wraps except the target and remove display
              if (parent) {
                document
                  .querySelectorAll(
                    '#' + parent.id + ' .content-wrap:not(#' + target + ')'
                  )
                  .forEach((wrap) => wrap.classList.remove('show'))
                document.getElementById(target)?.classList.add('show')
              }
            }
          }
        }
      })
    )
  }
})

const searchTrigger = document.querySelector(
  '[data-bs-target="navbarDropdownSearch"]'
)

searchTrigger?.addEventListener('click', () => {
  const searchInput = document.querySelector(
    '.search-input input'
  ) as HTMLInputElement
  searchInput?.focus()
})
